import { Remote } from "comlink";
import { GetState, SetState } from "zustand";
import { BetStore } from "..";
import isServer from "../../../libs/is-server";
import { Bet, BetRow } from "../../../types/bet";
import { IDBBetHandler } from "../../../workers/idb-bet-storer";
import { IDBBetSyncHandler } from "../../../workers/idb-bet-sync-handler";
import useAppStore, { ReductionRequirementView } from "../../app-store";
import uploadBet from "../upload-bet";
import { DEFAULT_AMOUNT_OF_RANKS, DEFAULT_RANK } from "./constants";

export const addAbcReduction = async (
  shouldUpdateReductionView: boolean,
  set: SetState<BetStore>,
  get: GetState<BetStore>,
  idbBetWorkerApi?: Remote<IDBBetHandler>,
  idbBetSyncWorkerApi?: Remote<IDBBetSyncHandler>
): Promise<void> => {
  const { bet } = get();

  const { currentBetId } = useAppStore.getState();

  if (!currentBetId || !bet) {
    return;
  }

  const { reductionRequirement } = bet;

  const addAbcReductionToRow = (row: BetRow): BetRow => {
    return {
      ...row,
      abcReduction: row.order.map(() => DEFAULT_RANK),
    };
  };

  const newBet: Bet = {
    ...bet,
    reductionRequirement: {
      ...reductionRequirement,
      abcReduction: {
        abcVariants: [
          {
            abcRows: [...Array(DEFAULT_AMOUNT_OF_RANKS)].map(() => ({
              legNumbers: bet.rows.map((row) => row.legNr),
              minWinners: null,
              maxWinners: null,
            })),
          },
        ],
      },
    },
    rows: bet.rows.map(addAbcReductionToRow),
  };

  set({
    bet: newBet,
    uploading: true,
  });

  if (shouldUpdateReductionView) {
    useAppStore
      .getState()
      .setReductionRequirementView(ReductionRequirementView.ABC);
  }

  if (!isServer) {
    uploadBet(
      currentBetId,
      newBet,
      () => set({ uploading: false }),
      idbBetSyncWorkerApi
    );

    if (idbBetWorkerApi) idbBetWorkerApi.storeBet(currentBetId, newBet);
  }
};
